"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CourierSelectionFlat = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _FlatLayoutWrapper = require("../shared/FlatLayoutWrapper");
var _SelectableCourier = require("./SelectableCourier");
var _useCourierSelection = require("./useCourierSelection");
var _jsxRuntime = require("react/jsx-runtime");
const CourierSelectionFlat = props => {
  const {
    activeCourier,
    hintMessages,
    isRefreshPending,
    isSelectedDeliveryLoading,
    onShippingOfferBannerClick,
    outOfStockQuantity
  } = props;
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    activateCourier,
    couriers,
    isAddressFormOpen,
    isCouriersLoading
  } = (0, _useCourierSelection.useCourierSelection)(props);
  const isLoading = isCouriersLoading || isSelectedDeliveryLoading || isRefreshPending;
  if (isAddressFormOpen) {
    return null;
  }
  if (isLoading && !couriers) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlatLayoutWrapper.FlatLayoutWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        children: formatMessage('deliveryMethod')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.SelectableCard, {
        loading: true,
        ...getTestIdProps(_models.TestId.SkeletonCourierBox)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.SelectableCard, {
        loading: true,
        ...getTestIdProps(_models.TestId.SkeletonCourierBox)
      })]
    });
  }
  if (!couriers || couriers.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlatLayoutWrapper.FlatLayoutWrapper, {
    ...getTestIdProps(_models.TestId.CourierSelection),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h6",
      children: formatMessage('deliveryMethod')
    }), couriers.map(courier => {
      const {
        deliveryChannelId
      } = courier;
      const isActive = Boolean(activeCourier === deliveryChannelId);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectableCourier.SelectableCourier, {
        activateCourier: activateCourier,
        courier: courier,
        hintMessages: hintMessages,
        isActive: isActive,
        isDisabled: isLoading,
        outOfStockQuantity: outOfStockQuantity,
        onShippingOfferBannerClick: onShippingOfferBannerClick
      }, deliveryChannelId);
    })]
  });
};
exports.CourierSelectionFlat = CourierSelectionFlat;
var _default = exports.default = CourierSelectionFlat;